/**
 * Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

RCA.client.Namecards = (function () {

    /* ----- Init --------------------------------------------------------------------------------------------------- */
    function Init() {
        $('#namecards').find('header').remove();
        if ('ncImage' in RCA.shared.AppData.settings) {
            let fg = RCA.shared.AppData.medias.find(function (item){
                return item.id == RCA.shared.AppData.settings.ncImage;
            });
            if (fg && fg.files[RCA.shared.localState.lang].file != undefined) {
                $("#namecards").find(".namecardscontainer").attr('style', 'background-image: url(\'' + fg.files[RCA.shared.localState.lang].file + '\')');
            }
        }
        $("#namecards").find(".namecardscontainer .namecardstitle").html(RCA.shared.AppData.profile.name ? RCA.shared.AppData.profile.name[RCA.shared.AppData.settings.lang] : '');
        $("#namecards").find(".namecardscontainer .namecardsubstitle").html(RCA.shared.AppData.profile.slogan ? RCA.shared.AppData.profile.slogan[RCA.shared.AppData.settings.lang] : '');
    }

    function showDetails() {
        Init();
    }

    /* ----- Public API --------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        showDetails: showDetails
    }
})();
